import { FeedbackModalContainer } from "@/components/modals";

/**
 * Web version ModalContainer - only includes modals that don't depend on Tauri
 * FolderSelectorContainer and UpdateSettingsContainer are not available in web version
 */
export const ModalContainer = () => {
  return (
    <>
      <FeedbackModalContainer />
    </>
  );
};
